import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import _ from 'lodash';
import Translate from 'translate';

import { FormGroup, Text, Select, DatePicker, Checkbox } from 'components/FormElements';
import { toggleAlertError, toggleLoading } from 'stores/actions/';

class ChannelsSearch extends React.Component {

  render() {
    const { options, onClose, open, filters, networkFilters, onSubmit } = this.props;

    let selectedOptions = [];
    if( _.filter( networkFilters, { active: true } ).length ) {
      if( _.find( networkFilters, { id: 'twitter', active: true } ) ) {
        selectedOptions.push( ..._.filter( options.socialAccounts, { type: 'tw' } ) )
      }
      if( _.find( networkFilters, { id: 'facebook', active: true } ) ) {
        selectedOptions.push( ..._.filter( options.socialAccounts, { type: 'fb' } ) )
      }
    } else selectedOptions = options.socialAccounts;

    return (
      <Modal closeOnEsc={false}
             little
             modalClassName="col-md-6"
             open={open}
             onClose={onClose}>
        <h5 className="mt-0"><Translate id="search"/></h5>

        <Form onSubmit={onSubmit}
              values={filters}
        >
          {( { getValue, submitForm, resetForm } ) =>
            <form onSubmit={submitForm}>
              <div className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="service"/></label>
                  <Select className="form-control font-weight-normal"
                          labelKey="service"
                          searchable={false}
                          options={options.services}
                          field="service"
                  />
                </FormGroup>

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="category"/></label>
                  <Select className="form-control font-weight-normal"
                          simpleValue={false} multi
                          options={options.categories} labelKey="category"
                          field="category"
                  />
                </FormGroup>

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="words"/></label>
                  <Text field="words" className="form-control"/>
                </FormGroup>

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="createdAt"/></label>
                  <DatePicker field="from" clearable/>
                </FormGroup>

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="account"/></label>
                  <Select className="form-control font-weight-normal"
                          options={selectedOptions} labelKey="name"
                          field="selectedSocialType"
                  />
                </FormGroup>

                <FormGroup containerClass="col-md-6 mt-4">
                  <Checkbox field="assignedToMe" label={<Translate id="assignedToMe"/>}
                            labelPosition="right"/>
                </FormGroup>
              </div>

              <div className="row">
                <div className="col-md-12 text-right">
                  <button className="btn btn-outline-secondary mr-2" type="button"
                          onClick={() => {
                            resetForm();
                            onSubmit()
                          }}
                  ><Translate id="clear"/></button>
                  <button className="btn btn-info"><Translate id="submit"/></button>
                </div>
              </div>
            </form>
          }
        </Form>
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( ChannelsSearch );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ChannelsSearch/index.js